import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A carriable good: a tied grain sack, ported 1:1 from the game's `goods` (the
// `grain` item's `held()` bundle). Authored about its own origin, at the small
// "held" scale a porter cradles — so it drops straight into a carry socket on
// the player or worker avatar via `bakeSockets`. A good is just a small model;
// nothing about it is avatar-specific.
const BURLAP = "#cda86a";   // sack body
const TIE = "#9c7c3e";      // the throat tie
const WHEAT = "#d9b65b";    // the grain tuft poking out

// One sack: a squashed icosahedron body, a cinched neck and a small grain tuft.
// `s` is the base scale; the game's grain sack uses s = 0.075.
function sackUnit(cx: number, cy: number, cz: number, s: number): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(s, 0), color: BURLAP, position: [cx, cy, cz], scale: [1, 0.92, 0.82] },
    { geometry: new THREE.CylinderGeometry(s * 0.34, s * 0.46, s * 0.3, 6), color: TIE, position: [cx, cy + s * 0.62, cz] },
    { geometry: new THREE.BoxGeometry(s * 0.5, s * 0.5, 0.012), color: WHEAT, position: [cx, cy + s * 0.85, cz], rotation: [0, 0, 0.3] },
  ];
}

export const grainSack = defineModel({
  id: "grain-sack",
  batchId: "characters",
  name: "Grain sack",
  tags: ["good", "cargo", "food"],
  fits: ["carry"],
  summary: "A tied grain sack — a carriable good for an avatar's carry socket.",
  description:
    "A single tied grain sack at held scale, ported from age-of-mcp's goods " +
    "(`grain`). Mount it in a player's or worker's `carry` socket to show the " +
    "figure hauling grain.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: (): Part[] => sackUnit(0, 0.05, 0.02, 0.075),
  animations: [],
});
